import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND, NAV_LINKS } from "@/lib/content";
import { BrandWordmark } from "@/components/landing/BrandWordmark";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#0B0410]/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo-home"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3 group"
        >
          <img
            src={BRAND.logoWhite}
            alt="EMB Consulting Group"
            className="h-14 w-14 object-contain shrink-0"
          />
          <BrandWordmark
            title="EMB Consulting Group"
            subtitle="Financial Planning · Regular Savings"
            containerClassName="hidden lg:inline-block leading-tight shrink-0"
            titleClassName="font-display text-[#F9F6F0] text-xl tracking-tight"
            subtitleClassName="text-[#A397B4] uppercase font-sans-emb mt-0.5"
            subtitleStyle={{
              fontSize: "0.55rem",
              lineHeight: "1",
              letterSpacing: "0.03em",
            }}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm text-[#F9F6F0]/80 hover:text-[#E6D5B8] transition-colors duration-300 font-medium whitespace-nowrap"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden p-2 text-[#F9F6F0]"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-[#0B0410]/95 backdrop-blur-xl border-t border-white/10"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-[#F9F6F0]/85 hover:text-[#E6D5B8] text-base"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta-agendar"
              onClick={() => go("contacto")}
              className="bg-[#3D1565] text-white px-6 py-3 rounded-sm mt-2"
            >
              Agendar asesoría
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navigation;
